import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  emails: yup.array().of(yup.string().email()).required(),
});

export function useSaveLeadNotificationEmailsMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });

      return http.post(HTTP_ENDPOINTS.saveLeadNotificationEmails(), {
        leads_notification_email: req.emails.join(","),
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.leadsNotificationEmails],
        });
        options.onSuccess?.(...args);
      },
    },
  );
}
